<!-- <button nz-button [nzType]="'primary'" routerLink="add" class="addbutton">
  Add Company
</button> -->

<h2 class="text-center page-heading">Customers</h2>
<div class="de-admin-container" nz-row [nzGutter]="[16, 16]">
  <div class="gutter-row" *ngFor="let list of companiesData" nz-col [nzSpan]="6">
    <div class="list">

      <h2 class="heading">
        {{ list.name }} <span style="font-size: 14px;">({{list.id}})</span>
        <!-- <a routerLink="{{ list.id }}">
        {{ list.name }}
      </a> -->
      </h2>

      <!-- <div class="name">
      <h4>Features</h4>
    </div>

    <div class="energy">
      <b>Solar</b>
      <span class="feature" *ngFor="let feature of list.features.solar">
        {{ features["solar"][feature] }}
      </span>
    </div>
    <div class="energy">
      <b>Wind</b>
      <span *ngFor="let feature of list.features.wind" class="feature">
        {{ features["wind"][feature] }}
      </span>
    </div> -->
      <div class="body">
        <button nz-button class="button custom-button " style="cursor: pointer" routerLink="{{ list.id }}">
          Show Sites
        </button>
      </div>
    </div>
  </div>


</div>


<div>
  <router-outlet></router-outlet>

</div>
